import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import { FC, useState } from "react";
import CreatePartner from "./CreatePartner";
import withModal from "lib/helpers/hoc/withModal";
import IconButton from "components/atoms/button/IconButton";
import { useTranslation } from "react-i18next";

export interface IPartnerResponse {
    name: string;
    logo: string
  }

export interface ICreatePartnerProcessProps {
  currentStep: number;
  setCurrentStep: (value: number) => void;
  onConfirm: () => void;
}

const CreatePartnerProcess: FC<ICreatePartnerProcessProps> = ({
  currentStep,
  onConfirm,
  setCurrentStep
}) => {
  const [response, setResponse] = useState<IPartnerResponse>({ name: '' , logo: ''});
  const {t} = useTranslation();
  return (
    <div>
      <ConditionalRender condition={currentStep === 1}>
        <CreatePartner onConfirm={onConfirm} setCurrentStep={setCurrentStep}  setResponse={setResponse}/>
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 2}>
        <div className="flex justify-center items-center flex-col mt-[30px]">
        <img src={`https://mainhub.insuhub.ch/api/partners/logo/${response.logo}`} loading="lazy" className="rounded-full w-[165px] h-[165px] mb-[44px] object-cover" alt="" />
          <h1 className="font-inter-semibold text-[22px] mb-[22px]">{t("Congratulations !")}</h1>
          <p className="text-[#282D46] font-inter-medium mx-auto text-[18px] w-full text-center">{t("Partner")} {response?.name} {t("have been created successfully.")}</p>
          <IconButton
            onClick={() => {
                onConfirm();
                setCurrentStep(1);
            }}
            className={`min-w-[333px] mt-[53px] mb-[45px]`}
            type="button"
          >
            {t("Got To Partners")}
          </IconButton>
        </div>
      </ConditionalRender>
    </div>
  );
};

export default withModal(CreatePartnerProcess);
